// Show a temporary "snackbar" message
//
// Eg: error('These words at bottom of page!')

import $ from 'jquery';

const ALERT_TIME = 5000;

const notifyError = function(message, time) {
  notify(message, 'error', time);
};

const notify = function(message, type, time = ALERT_TIME) {
  const el = enterNotify(message, type);
  setTimeout(() => {
    exitNotify(el);
  }, time);
};

const enterNotify = function(message, type) {
  return $('<div class="snackbar snackbar--entering">')
    .addClass(`snackbar--${type}`)
    .text(message)
    .appendTo('body')
    .one(
      'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
      function() {
        $(this).removeClass('snackbar--entering');
      }
    );
};

const exitNotify = function(el) {
  el.addClass('snackbar--leaving').one(
    'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
    function() {
      $(this).remove();
    }
  );
};

export default notifyError;
